module.exports = __webpack_public_path__ + "img/9788991095922.f4745c0e.jpg";